import { useAuthActions, useAuthContext } from "@contexts/auth";
import { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";

const AppContainer = () => {
  const { user, cookieChecked } = useAuthContext();
  const { checkAuth } = useAuthActions();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    checkAuth();
  }, []);

  useEffect(() => {
    if (cookieChecked) {
      if (pathname.includes('registerForm') || pathname.includes('clientForm')) return
      if (!user && !pathname.includes("/access")) {
        navigate("/access")
      } else if (user && !pathname.includes("/dashboard")) {
        if (user.roles.includes("bim")) navigate("/dashboard/bim/cadastro");
        if (user.roles.includes("costs")) navigate("/dashboard/costs/obras");
        if (user.roles.includes("ampli") || user.roles.includes("admin")) navigate("/dashboard")
      }
    }
  }, [user, cookieChecked])

  return <Outlet />
}

export default AppContainer;